import React from 'react';
import { Button, Text } from '../../Atoms';
import { Input } from '../../Molecules';
import { SelectOrganism } from '../../Organisms';
function TemplateSimulateurRembourcementScreen2(props) {
    return (
        <>
            <div className='first-line-simulateur-remboursement-step-2' >
                <div>
                    <Text
                        text='Acte dans le parcours de soins'
                        className='btn-radio-simulateur-remboursement-label'
                    />
                    <div className='btn-radio-simulateur-remboursement-container'>
                        <div style={{ display: 'flex' }}>
                            <div 
                                className={props.actesDansParcoursDeSoins === true 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' }
                                    onClick={() => props.onChangeBtnRadioStep2('actesDansParcoursDeSoins', true)}
                                    ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('actesDansParcoursDeSoins', true)}
                            >Oui</span>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={props.actesDansParcoursDeSoins === false 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' }
                                    onClick={() => props.onChangeBtnRadioStep2('actesDansParcoursDeSoins', false)}
                                    ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('actesDansParcoursDeSoins', false)}
                            >Non</span>
                        </div>
                    </div>
                </div>
                <div className='margin-btn-radio-simulateur-remboursement' >
                    <Text
                        text='Secteur conventionné'
                        className='btn-radio-simulateur-remboursement-label'
                    />
                    <div className='btn-radio-simulateur-remboursement-container'>
                        <div style={{ display: 'flex' }}>
                            <div className={props.secteurConventionne === true 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' }
                                    onClick={() => props.onChangeBtnRadioStep2('secteurConventionne', true)}
                                    ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('secteurConventionne', true)}
                            >Oui</span>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={props.secteurConventionne === false 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' }
                                    onClick={() => props.onChangeBtnRadioStep2('secteurConventionne', false)}
                                    ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('secteurConventionne', false)}
                            >Non</span>
                        </div>
                    </div>
                </div>
                <div className='margin-btn-radio-simulateur-remboursement'>
                    <Text
                        text='Optam'
                        className='btn-radio-simulateur-remboursement-label'
                    />
                    <div className='btn-radio-simulateur-remboursement-container'>
                        <div style={{ display: 'flex' }}>
                            <div className={props.optam === true 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' } 
                                    onClick={() => props.onChangeBtnRadioStep2('optam', true)}
                                    ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('optam', true)}
                            >Oui</span>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <div className={props.optam === false 
                                    ? 'btn-selected-radio-simulateur-remboursement' 
                                    : 'btn-radio-simulateur-remboursement' }
                                    onClick={() => props.onChangeBtnRadioStep2('optam', false)}
                                     ></div>
                            <span className="btn-radio-value-simulateur-remboursement"
                            onClick={() => props.onChangeBtnRadioStep2('optam', false)}
                            >Non</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='simulateur-remboursement-price-container' >
                <Text
                    text='Montant de la dépense :'
                    className='price-simulateur-remboursement-label'
                />
                <div style={{ width: '40px' }}>
                    <Input
                        placeholder=''
                        className='input-price-simulateur-remboursement'
                        onChange={(e) => props.onChangePrice(e.target.value)}
                        value={props.price}
                    />
                </div>
                <Text
                    text='€'
                    className='price-simulateur-remboursement-unit'
                />
            </div>
            <div className='unkown-price-simulateur-remboursement-container' >
                <div 
                className={props.unkownPrice 
                    ? 'btn-selected-radio-simulateur-remboursement' 
                    : 'btn-radio-simulateur-remboursement'}
                    onClick={() => props.onChangeUnkonwnPrice(!props.unkownPrice)}
                    ></div>
                <span 
                    className="btn-radio-value-simulateur-remboursement"
                    onClick={() => props.onChangeUnkonwnPrice(!props.unkownPrice)}
                >Je ne connais pas le montant de la dépense</span>
            </div>
            <div className='select-regime-container-simulateur-remboursement' >
                <SelectOrganism
                    placeholder=' '
                    inputLabel='Régime obligatoire'
                    classNameInput='select-simulateur-remboursement-regime'
                    classNameIcon='icon-select-simulateur-remboursement'
                    iconSize={8}
                    classNameSelectMenu='input-select-simulateur-remboursement-regime'
                    classNameOptionContainer='select-option-container-simulateur-remboursement'
                    classNameSelectedOption='selected-option-container-simulateur-remboursement'
                    showModalView={false}
                />
            </div>
            <div className='btn-next-container-simulateur-remboursement'>
                <Button
                    text='Suivant'
                    className={'btn-next-simulateur-remboursement'}
                    onClick={() => props.nextStep(2)}
                />
            </div>
        </>

    );
}

export default TemplateSimulateurRembourcementScreen2;
